export enum TablePictureEnum {
  Table1='./assets/images/tables/2_round.png',
  Table2='./assets/images/tables/2_square.png',
  Table3='./assets/images/tables/4_round.png',
  Table4='./assets/images/tables/6_round.png',
  Table5='./assets/images/tables/6_square.png',
  Table6='./assets/images/tables/8_square.png',
  Table7='./assets/images/tables/10_round.png',
  Table8='./assets/images/tables/10_square.png',
}

export class TableTypeConfigModel {
  static readonly Table1  = new TableTypeConfigModel('Table1', 2);
  static readonly Table2  = new TableTypeConfigModel('Table2', 2);
  static readonly Table3  = new TableTypeConfigModel('Table3', 4);
  static readonly Table4  = new TableTypeConfigModel('Table4', 6);
  static readonly Table5  = new TableTypeConfigModel('Table5', 6);
  static readonly Table6  = new TableTypeConfigModel('Table6', 8);
  static readonly Table7  = new TableTypeConfigModel('Table7', 10);
  static readonly Table8  = new TableTypeConfigModel('Table8', 10);


  // private to disallow creating other instances of this type
  private constructor(private readonly key: string, public readonly value: number) {
  }

  toString() {
    return this.key;
  }
}
